module.exports = __webpack_public_path__ + "img/state_red.a22e7a4e.png";